/**
 * The wording a session's items had when the session opened for ranking
 * (owner ruling R4, PRD-item-versions). Before the session opens there is
 * nothing to hold, so today's wording shows. Returns a function that, given an
 * item id and today's wording, gives the wording the session ranks.
 */
import { useCallback, useEffect, useState } from 'react';
import { fetchItemWordingAsOf, type ItemWording } from '@/lib/itemVersionsService';

export function useSessionStartWording(itemIds: readonly string[], openedAt: Date | string | null | undefined) {
  const [wording, setWording] = useState<Map<string, ItemWording>>(new Map());
  const key = openedAt ? `${typeof openedAt === 'string' ? openedAt : openedAt.toISOString()}|${[...itemIds].sort().join(',')}` : '';

  useEffect(() => {
    let live = true;
    if (!key) {
      setWording(new Map());
      return;
    }
    const [at, ids] = key.split('|');
    void fetchItemWordingAsOf(ids ? ids.split(',') : [], at).then((m) => {
      if (live) setWording(m);
    });
    return () => {
      live = false;
    };
  }, [key]);

  return useCallback(
    (itemId: string, today: { title: string; description?: string | null }) => {
      const then = wording.get(itemId);
      return then ? { title: then.title, description: then.description ?? '' } : { title: today.title, description: today.description ?? '' };
    },
    [wording],
  );
}
